import * as React from 'react';
import OPLabel from 'src/view/op-label';
export default function Code(props) {
    const { value = '', options = {} } = props;
    const { lenLimit, maxLength, hightlightNum = 4, highlightLength, copyable = true, } = options;
    const maxLen = lenLimit || maxLength;
    const highlightLen = hightlightNum * -1 || highlightLength;
    return (React.createElement(OPLabel, { label: value, maxLength: maxLen, highlightLength: highlightLen, copyable: copyable }));
}
